<script>
import SortAscending from "../Vectors/SortAscending.svelte";
import SortDescending from "../Vectors/SortDescending.svelte";

    export let sortElement = "";
    export let selectedSortDirection = 1;
    export let selectedSortElement = "none";
</script>

{#if sortElement == selectedSortElement}
    {#if selectedSortDirection == 1}
        <SortAscending></SortAscending>
    {:else}
        <SortDescending></SortDescending>
    {/if}
{/if}
